import { useContext, useEffect, useState } from 'react';
import { OpenedInviteCard } from '../../useProjectTeamInvite';
import { emailValidate } from '../../../../../shared/helpers/validators';
import { addEmployer } from '../../../../../TemporaryConmonents/AddProject/helpers/actions';
import { EmployersForSelect } from '../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { useDispatch } from 'react-redux';
import { onAddProjectUser } from '../../../../../store/slices/dashboardSlice/action';
import { Roles } from '../../../../../TemporaryConmonents/AddProject/types/types';
import { AddProjectContext } from '../../../../../TemporaryConmonents/AddProject/Context/AddProjectContext';

export const useInviteCard = (
    openedInviteCard: OpenedInviteCard,
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void,
    type: string,
    employersList: EmployersForSelect[],
    isDash?: boolean,
    onEmployersListSet: (value: string) => void,
    onSetClosingCard: (value: string) => void,
    closingCard: string
) => {
    const dispatch = useDispatch();
    const { projectId, setProjectsUsers } = useContext(AddProjectContext);

    const [animate, setAnimate] = useState(false);
    const [query, setQuery] = useState('');
    const [validateError, setValidateError] = useState(null);
    const [selectedPerson, setSelectedPerson] = useState(null);

    const onOpenCard = () => {
        if (!!openedInviteCard) {
            onSetClosingCard(openedInviteCard);
        }
        setAnimate(true);
        onOpenedInviteCardChange(type as OpenedInviteCard);
    };

    const onCloseCard = () => {
        setAnimate(true);
        onOpenedInviteCardChange(null);
        setQuery('');
        onEmployersListSet('');
        setSelectedPerson(null);
        setValidateError('');
    };

    const isOpened = openedInviteCard === type;

    useEffect(() => {
        const handleClick = () => {
            if (isOpened) onCloseCard();
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [isOpened]);

    useEffect(() => {
        if (!!closingCard) {
            if (closingCard === type) {
                onEmployersListSet('');
                onSetClosingCard(null);
            }
        }
    }, [closingCard]);

    const onAddEmployer = () => {
        let error = null;

        if (!selectedPerson) {
            error = emailValidate(query);
        }

        if (!!error) {
            setValidateError(error);
            return;
        }

        if (isDash) {
            dispatch(
                onAddProjectUser({
                    email: !!employersList.length && selectedPerson ? selectedPerson.email : query,
                    role: type === Roles.PURCHASER ? 'purchase_agent' : type,
                })
            )
                //@ts-ignore
                .unwrap()
                //@ts-ignore
                .then((data) => {
                    setQuery('');
                    setSelectedPerson(null);
                    onCloseCard();
                    onEmployersListSet('');
                })
                //@ts-ignore
                .catch((error) => {
                    if (error.status === 'tariff-error') {
                        if (!error.is_owner) {
                            setValidateError(error.message);
                        } else {
                            //@ts-ignore
                            const url = routable.getRoute('openChangeTariff');
                            $.modalable('open', { url: url });
                        }
                    }
                    if (error.status === 'error') {
                        setValidateError(error.message);
                    }
                });
        } else {
            addEmployer(projectId, {
                email: !!employersList.length && selectedPerson ? selectedPerson.email : query,
                role: type === Roles.PURCHASER ? 'purchase_agent' : type,
            }).then((response) => {
                if (response.status === 'tariff-error') {
                    if (!response.is_owner) {
                        setValidateError(response.message);
                    } else {
                        //@ts-ignore
                        const url = routable.getRoute('openChangeTariff');
                        //@ts-ignore
                        $.modalable('open', {
                            url: url,
                        });
                    }
                }
                if (response.status === 'error') {
                    setValidateError(response.message);
                } else {
                    setProjectsUsers(response.data.project_users);
                    setQuery('');
                    setSelectedPerson(null);
                    onCloseCard();
                    onEmployersListSet('');
                }
            });
        }
    };

    return {
        isOpened,
        validateError,
        query,
        setQuery,
        selectedPerson,
        setSelectedPerson,
        onCloseCard,
        onAddEmployer,
        animate,
        onOpenCard,
    };
};
